function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 14.667A6.667 6.667 0 118 1.333a6.667 6.667 0 010 13.334zm-.667-10a.667.667 0 111.334 0V8a.667.667 0 11-1.334 0V4.667zM8 10a.667.667 0 100 1.333A.667.667 0 008 10z"
});

var SvgExclamationSolid = function SvgExclamationSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16"
  }), _ref);
};

export default SvgExclamationSolid;